<div class="grid-x margin-top">
  <div class="cell small-12">
    <h2 class="no-margin-bottom">Create Communications</h2>
    <!-- <a class="tiny" href="/admin/communications">Manage</a> -->
  </div>
</div>

<div class="grid-x margin-bottom grid-padding-x grid-padding-y align-bottom">
  <div class="cell small-12 medium-4">
    <label>Select Type:</label>
    @if (dataLoaded()) {
      <select class="no-margin"
        (change)="typeChanged($event.target.value)">
        <option value="">...</option>
        @for (type of types; track type) {
          <option [value]="type.Code">{{ type.Definition }}
          </option>
        }
      </select>
    } @else {
      Loading...
    }
  </div>
  <div class="cell small-12 medium-4">
    <label>Select Category:</label>
    @if (activeCategories?.length) {
      <select class="no-margin"
        (change)="categoryChanged($event.target.value)">
        <option value="">...</option>
        @for (category of activeCategories; track category) {
          <option [value]="category.Code">{{ category.Definition }}
          </option>
        }
      </select>
    } @else {
      Select Type...
    }
  </div>
  <div class="cell small-12 medium-4">
    <label>Select Template:</label>
    @if (types && activeCategories?.length) {
      <select class="no-margin"
        (change)="templateChanged($event.target.value)" [disabled]="!selectedCategory">
        <option value="">...</option>
        @for (template of activeTemplates; track template) {
          <option [value]="template.id">{{ template.name }}
          </option>
        }
      </select>
    } @else {
      Select Type, Category...
    }
  </div>
  <div class="cell small-12 medium-12">
    <button (click)="instantiate()" class="button no-margin" [disabled]="!selectedTemplateId">
      Add Communication
    </button>
  </div>
</div>